exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-pie.js
// module id = 24
// module chunks = 1